// Profile.js
import React from 'react';
import styles from './Profile.module.css';
import { Outlet } from 'react-router-dom';
import Topbar from '../../Components/Topbar/Topbar';;

export const TopbarData = [
  {
    title: 'Leave',
    link: '/Profile/Leave',
    disabled: false,
  },
  {
    title: 'Sickness',
    link: '/Profile/Sickness',
    disabled: false,
  },
  {
    title: 'User',
    link: '/Profile/User',
    disabled: false,
  },
];

function Profile() {
  return (
    <div className={styles.profileContainer}>
      <Topbar TopbarData={TopbarData}  />
      <Outlet />
    </div>
  );
}

export default Profile;